import React from 'react'
import PropTypes from 'prop-types'

import filterIcon from 'images/filter-icon.svg'
import Button from 'component/Button/index'
import FilterIconSVG from 'component/svgComponents/filter'

const Options = ({
  setOpenEditModal = () => {},
  setSideFilterVisible = () => {},
  translate = () => {},
}) => (
  <div className='float-right margin-top'>
    <Button
      className='btn btn-primary margin-right'
      onClick={setOpenEditModal}
      text={translate('linear.conference.justification.new.button')}
    />
    <Button
      className='btn btn-secondary'
      icon={filterIcon}
      svgIcon
      svgComponent={<FilterIconSVG className="margin-default-svg" newDesign={false} />}
      onClick={setSideFilterVisible}
      text={translate('linear.conference.justification.filter.button')}
    />
  </div>
)

Options.propTypes = {
  setOpenEditModal: PropTypes.func.isRequired,
  setSideFilterVisible: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Options
